/**
 * Registers the offline app shell (public/sw.js) in production builds.
 *
 * Automated browsers skip it unless the URL carries `?offline-shell`, so the
 * existing browser tests keep full control of network mocks (a service worker
 * would hide requests from Playwright's routing).
 */
export function registerOfflineShell(
  nav: Navigator = navigator,
  search: string = location.search,
  production: boolean = import.meta.env.PROD,
) {
  if (!production || !('serviceWorker' in nav)) return false;
  if (nav.webdriver && !new URLSearchParams(search).has('offline-shell')) return false;
  void nav.serviceWorker.register('/sw.js').catch(() => {});
  return true;
}
